module.exports = __webpack_public_path__ + "img/newsIndImg2.83a06f16.png";